import React, { useState, useCallback } from 'react';
import AppIcon from './AppIcon';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../../services/canvasUtils'; // 🟢 注意引用路径改为 services
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useAuth } from '../../context/AuthContext';

const AvatarUploadModal = ({ onClose, onUploadSuccess }) => {
  const { user } = useAuth();
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [uploading, setUploading] = useState(false);

  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setImageSrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    try {
      setUploading(true);
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      
      const storage = getStorage();
      const storageRef = ref(storage, `avatars/${user.uid}.jpg`);
      
      await uploadBytes(storageRef, croppedImageBlob);
      const downloadUrl = await getDownloadURL(storageRef);
      
      onUploadSuccess(downloadUrl);
    } catch (e) {
      console.error(e);
      alert('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="bg-white w-full max-w-md rounded-2xl overflow-hidden shadow-2xl flex flex-col max-h-[90vh]">
        <div className="p-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-bold">Upload Custom Photo</h3>
          <button onClick={onClose}><AppIcon name="times" /></button>
        </div>

        <div className="p-4 flex-1 overflow-y-auto">
          {!imageSrc ? (
            <label className="flex flex-col items-center justify-center h-64 border-2 border-dashed rounded-xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition">
              <AppIcon name="cloud-upload-alt" className="text-4xl text-gray-400 mb-2" />
              <span className="text-gray-500 mb-2">Click to select image</span>
              <input type="file" accept="image/*" onChange={onFileChange} className="hidden" />
            </label>
          ) : (
            <div className="relative h-64 w-full bg-black rounded-xl overflow-hidden">
              <Cropper 
                image={imageSrc} 
                crop={crop} 
                zoom={zoom} 
                aspect={1} 
                cropShape="round"
                onCropChange={setCrop} 
                onZoomChange={setZoom} 
                onCropComplete={(_, pixels) => setCroppedAreaPixels(pixels)} 
              />
            </div>
          )}
          {imageSrc && (
            <div className="mt-4">
              <label className="text-xs font-bold text-gray-500">ZOOM</label>
              <input type="range" value={zoom} min={1} max={3} step={0.1} onChange={(e) => setZoom(e.target.value)} className="w-full mt-1" />
            </div>
          )}
        </div>

        <div className="p-4 border-t flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 font-bold text-gray-600 hover:bg-gray-100 rounded-lg">Cancel</button>
          <button onClick={handleUpload} disabled={!imageSrc || uploading} className="px-6 py-2 bg-purple-600 text-white font-bold rounded-lg disabled:opacity-50">
            {uploading ? 'Saving...' : 'Save Avatar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvatarUploadModal;